/**
 * Pure result-badge labelling — no React / UI dependencies, so it is testable.
 *
 * `preStrikes` is the count BEFORE this pitch, which is what makes "strike
 * three" mean `preStrikes === 2`. Callers must pass the server's own pre-pitch
 * snapshot (`pitch_reveal.context.strikes`), NOT live client state: the client's
 * count races the `game_state` broadcast, and if that has already applied the
 * value is post-pitch — which showed STRIKEOUT on strike two and showed nothing
 * on the real strike three.
 */
export function resultLabelFor(resultType, contact, preStrikes = 0) {
  if (resultType === "calling_your_shot_hr") return { label: "HOME RUN!", color: "bg-emerald-600", desc: "Called shot! D20=20 — it's gone!" };
  if (resultType === "calling_your_shot_out") return { label: "Out!", color: "bg-red-700", desc: "Called shot! D20=1 — batter is out" };
  if (resultType === "calling_your_shot_strike") return { label: "Strike!", color: "bg-orange-700", desc: "Swung and missed — strike" };
  if (resultType === "wild_pitch") return { label: "Wild Pitch", color: "bg-purple-600", desc: "Runners advance. +1 Ball." };
  if (resultType === "hit_by_pitch") return { label: "Hit by Pitch", color: "bg-orange-600", desc: "Batter takes first!" };
  if (resultType === "ball") return { label: "Ball", color: "bg-blue-600", desc: "Pitcher throws a ball" };
  if (resultType === "foul") return { label: "Foul Ball", color: "bg-slate-600", desc: "Strike (unless 2)" };
  if (resultType === "strike") {
    if (preStrikes >= 2) return { label: "STRIKEOUT!", color: "bg-red-600", desc: "Batter strikes out!" };
    return { label: "Strike", color: "bg-red-600", desc: "Pitcher wins!" };
  }
  if (resultType === "slap_hit_single" || resultType === "slap_hit_single_auto") return { label: resultType === "slap_hit_single_auto" ? "Slap Hit! (Auto)" : "Slap Hit!", color: "bg-emerald-500", desc: "Weak contact → automatic single!" };
  if (resultType === "in_play") {
    if (contact >= 7) return { label: "CRUSHED!", color: "bg-emerald-600", desc: "Absolutely demolished!" };
    if (contact >= 5) return { label: "Smashed!", color: "bg-emerald-600", desc: "Driven deep!" };
    if (contact >= 3) return { label: "Solid Contact!", color: "bg-emerald-600", desc: "Good contact!" };
    if (contact >= 1) return { label: "Weak Contact", color: "bg-emerald-600", desc: "Just got a piece of it" };
    return { label: "Dribbler", color: "bg-emerald-600", desc: "Barely made contact" };
  }
  return { label: "—", color: "bg-slate-600", desc: "" };
}
